var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sportBanners.length)?_c('div',_vm._l((_vm.sportBanners),function(ad,index){return _c('v-col',{key:index+'_ad',staticClass:"no-padding ad",attrs:{"cols":"12","md":"12"}},[_c('img',{attrs:{"src":ad.image,"alt":ad.name}})])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }